import { fetchInvisibleNotification, markNotificationAsRead } from '../service';
import { useEffect } from 'react';
import { useNotification } from '../components/NotificationProvider';

export const useMarkNotificationAsRead = () => {
  const { notificationData, setNotificationData } = useNotification();
  useEffect(() => {
    const markAsReadOperation = async () => {
      const hasNewConnection = !!notificationData.newConnection;
      if (hasNewConnection) {
        const notificationGuid = notificationData.newConnection?.guid || '';
        try {
          console.debug(`Mark notification ${notificationGuid} as read`);
          await markNotificationAsRead(notificationGuid);
          const notificationData = await fetchInvisibleNotification(
            'NEW_USER_CONNECTION',
          );
          setNotificationData(notificationData);
        } catch (e) {
          console.debug(`Error mark notification ${notificationGuid} as read`);
        }
      }
    };
    markAsReadOperation();
  }, [notificationData, setNotificationData]);
};
